import { SelectOneAppUserHook } from 'components/core/search/users'
import { AccessRequest } from 'components/pages/accessrequest/create/form-v2/RequestAccessFormV2'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { Control, Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'

type Props = {
    control: Control<AccessRequest>
    error?: string
    disabled?: boolean
    appId: string
    userId: string
}

export const AccessRequestAppUserField = ({ control, error, disabled, appId, userId }: Props): React.ReactElement | null => {
    const intl = useIntl()

    return <Controller
        name="appUser"
        control={control}
        render={({ field }): React.ReactElement => (
            <SelectOneAppUserHook
                id="appUser"
                onSelected={field.onChange}
                onBlur={field.onBlur}
                value={field.value as unknown as AppUserValue}
                placeholder={intl.formatMessage({
                    id: 'component_access_request_app_user_input_placeholder',
                    defaultMessage: 'Select an account',
                })}
                reqOptions={{ appId, userIds: [userId] }}
                reqExpandMask={{ paths: ['*'] }}
                helperText={error}
                error={!!error}
                disabled={disabled}
                fullWidth
                label={undefined}
                showEnhancedSearch={false}
            />
        )}
    />
}
